// 获取userinfo接口
import * as http from '../http.js';
export const login = params => http.post('/v184/login', params)
export const getcode = params => http.get('/v184/login/code', params)
export const loginout = params => http.get('/v184/logout', params)
//直播设置页
export const getSetInfo = params => http.get('/v184/set/room', params)
export const saveLiveInfo = params => http.post('/v184/save/room', params)
export const getTenCloudConf = params => http.get('/v184/cos/configure', params)
export const getSecretKey = params => http.get('/v184/file/token', params)
export const uploadPic = params => http.post('/v198/upload/pic', params, 'file') //上传图片
//用户信息
export const getUserInfo = params => http.get('/v184/user/info', params)
//节目管理
export const getlivePlan = params => http.get('/v184/plan', params) //当前已添加所有计划
export const getfirst = params => http.get('/v184/cate', params)    //获取搜索条件框一级赛事
export const getsecond = params => http.get('/v184/events', params) //获取搜索条件框二级赛事
export const getAllplans = params => http.get('/v184/match/plan', params)      //添加直播页 所有数据
export const addliveplan = params => http.post('/v184/add/plan', params)       //添加直播计划接口
export const startOrOverLive = params => http.post('/v184/send/open', params)  //开始或结束直播
export const cancelPlan = params => http.post('/v184/del/plan', params)        //取消直播计划
export const modifyPlan = params => http.post('/v184/update/plan', params)     //修改直播计划
export const delPlan = params => http.post('/v184/del/plan', params)           //取消直播计划
export const delPlansc = params => http.post('/v191/del/plan', params)           //取消直播计划
export const getPull = params => http.get('/v184/room/go', params)             //正在直播刷新流地址
export const editorUser = params => http.patch('/v184/user', params)            //修改头像和昵称
export const getRoomManage = params => http.get('/v184/room/manage', params)   //房管列表
export const addOrRemoveManage = params => http.post('/v184/add/manage', params)//新增或撤销房管
export const setMute = params => http.post('/v184/room/mute', params)           //禁言设置/取消
export const getMuteList = params => http.get('/v184/user/mute', params)        //禁言列表
export const getMyincome = params => http.get('/v184/user/amount', params)      //获取我的收益
export const getAllplat = params => http.get('/v184/platform/list', params)      //获取当前所有直播平台
export const getcommplat = params => http.get('/v184/platform/list', params)    //获取当前公用直播平台
export const getIncomeType = params => http.get('/v184/income', params)         //获取当前收益类型
export const getMyFans = params => http.get('/v184/fans/list', params)          //获取我的粉丝团
export const applyOrModify = params => http.post('/v184/fans/apply', params)    //申请主播粉丝团和修改徽章名称
export const roomNotice = params => http.get('/v194/room/notice', params)
export const quchaibtn = params => http.get('/v196/quchai/btn', params) //获得是否需要展示趣猜入口
export const quchailist = params => http.get('/v196/quchai', params) //获得趣猜裂变
export const quchaiguess = params => http.patch('/v196/guess', params) //结算趣猜
export const quchaifaqi = params => http.post('/v196/guess', params) //发起趣猜
export const quchaiOdds = params => http.get('/v196/quchai/odds', params) //5S轮训 展示获取趣猜列表赔率投注金额参加人数

export const roomDrawStatus = params => http.get('/v198/draw/config', params) // 直播间抽奖按钮状态查询
export const roomDrawRecord = params => http.get('/v198/draw/record', params) // 直播间-抽奖-抽奖记录
export const roomDrawWinners = params => http.get('/v198/draw/winners', params) // 直播间-抽奖-中奖名单
export const drawAmountInfo = params => http.get('/v198/draw/remaining_amount_info', params) // 获取本月剩余的抽奖金币和兑换券
export const drawVoucherList = params => http.get('/v198/draw/shops', params) // 获取抽奖可选兑换券列表
export const drawGiftsList = params => http.get('/v198/draw/gifts', params) // 获取指定礼物下拉框列表
export const submitDraw = params => http.post('/v196/draw', params) // 提交抽奖


